import { useEffect, useState } from "react";
import supabase from "./supabase";
import "./styles.css";

const CATEGORIES = [
  { name: "technology", color: "#3b82f6" },
  { name: "science", color: "#16a34a" },
  { name: "finance", color: "#ef4444" },
  { name: "society", color: "#eab308" },
  { name: "entertainment", color: "#db2777" },
  { name: "health", color: "#14b8a6" },
  { name: "history", color: "#f97316" },
  { name: "news", color: "#8b5cf6" },
];

function App() {
  const [showform, setshowform] = useState(false);
  const [factslist, setfactlist] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [currentcategory, setcategory] = useState("all");

  useEffect(
    function () {
      setisloading(true);
      async function getFactss() {
        let query = supabase.from("facts").select("*");
        if (currentcategory !== "all")
          query = query.eq("category", currentcategory);
        let { data: facts, error } = await query
          .order("likes", { ascending: false })
          .limit(100);
        //console.log(facts);
        setisloading(false);
        if (!error) setfactlist(facts);
        else alert("There is a problem in getting data");
      }
      getFactss();
    },
    [currentcategory]
  );
  return (
    <>
      {/* Header */}
      <Header setshowform={setshowform} showform={showform} />

      {showform ? (
        <Newform setfactlist={setfactlist} setshowform={setshowform} />
      ) : null}
      <main className="main">
        <Category setcategory={setcategory} />
        {isloading ? (
          <Loarding />
        ) : (
          <Factlist factslist={factslist} setfactlist={setfactlist} />
        )}
        {/* <Factlist factslist={factslist} /> */}
      </main>
    </>
  );
}

function Loarding() {
  return <p className="loadmessage">Loading...</p>;
}

function Header({ setshowform, showform }) {
  const apptitle = "Today I learned";
  return (
    <header className="header">
      <div className="logo">
        <img src="logo.png" alt="logo" width="68" height="68" />
        <h1>{apptitle}</h1>
      </div>
      <button
        className="btn btn-large btn-open"
        onClick={() =>
          setshowform((c) => !c)
        } /* we can use (c) => (showform ? false : true) */
      >
        {showform ? "Close" : "share a fact"}
      </button>
    </header>
  );
}

function Newform({ setfactlist, setshowform }) {
  const [text, settext] = useState("");
  const [source, setsource] = useState("http://example.com");
  const [category, setcategory] = useState("");
  const [isupload, setisupload] = useState(false);

  function isValidHttpUrl(string) {
    let url;

    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
  }

  async function Handlesubmit(e) {
    //1. prevent browser from reload
    e.preventDefault();
    if (text && isValidHttpUrl(source) && category) {
      // const newfact = {
      //   id: Math.round(Math.random() * 100000),
      //   text,
      //   source,
      //   category,
      //   likes: 0,
      //   dislikes: 0,
      //   fake: 0,
      //   createdIn: new Date().getFullYear(),
      // };
      //upload data in supabase
      setisupload(true);
      const { data: newfact, error } = await supabase
        .from("facts")
        .insert([{ text, source, category }])
        .select();
      setisupload(false);
      if (!error) setfactlist((facts) => [newfact[0], ...facts]);
      //reset form
      settext("");
      setsource("");
      setcategory("");
      //close the form
      setshowform(false);
    }
  }

  return (
    <form className="forms" onSubmit={Handlesubmit}>
      <input
        className="inp"
        type="text"
        placeholder="Share a fact"
        value={text}
        onChange={(e) => settext(e.target.value)}
        disabled={isupload}
      />
      <span>{200 - text.length}</span>
      <input
        type="text"
        placeholder="Source link"
        value={source}
        onChange={(s) => setsource(s.target.value)}
        disabled={isupload}
      />
      <select
        value={category}
        onChange={(c) => setcategory(c.target.value)}
        disabled={isupload}
      >
        <option value="" disabled={isupload}>
          CHOOSE
        </option>
        {CATEGORIES.map((c) => (
          <option key={c.name} value={c.name}>
            {c.name.toUpperCase()}
          </option>
        ))}
      </select>
      <button class="btn btn-large">submit</button>
    </form>
  );
}

function Category({ setcategory }) {
  return (
    <aside>
      <ul>
        <li className="btn btn-all" onClick={() => setcategory("all")}>
          all
        </li>
        {CATEGORIES.map((cat) => (
          <li
            className="btn btn-cat"
            style={{ backgroundColor: cat.color }}
            onClick={() => setcategory(cat.name)}
          >
            {cat.name}
          </li>
        ))}
      </ul>
    </aside>
  );
}

function Factlist({ factslist, setfactlist }) {
  return (
    <section>
      <ul className="fact-list">
        {factslist.length !== 0 ? (
          factslist.map((facts) => (
            <Facts key={facts.id} facts={facts} setfactlist={setfactlist} />
          ))
        ) : (
          <p className="loadmessage">No Facts in this category</p>
        )}
      </ul>
    </section>
  );
}

function Facts({ facts, setfactlist }) {
  const isdisputed = facts.likes + facts.dislikes < facts.fake;
  async function likehandle(colname) {
    const { data: updatedfact, error } = await supabase
      .from("facts")
      .update([{ [colname]: facts[colname] + 1 }])
      .eq("id", facts.id)
      .select();
    if (!error)
      setfactlist((factss) =>
        factss.map((f) => (f.id === facts.id ? updatedfact[0] : f))
      );
  }

  return (
    <li>
      <div className="fact">
        <p>
          {isdisputed ? (
            <p style={{ backgroundColor: "#ef4444", display: "inline-block" }}>
              [💀 possibly not True]
            </p>
          ) : null}
          {facts.text}
          <a className="links" href={facts.source} target="_blank">
            (source)
          </a>
        </p>
        <span
          className="tag"
          style={{
            backgroundColor: CATEGORIES.find((el) => el.name === facts.category)
              .color,
          }}
        >
          {facts.category}
        </span>
      </div>
      <div class="score">
        <button className="btn" onClick={() => likehandle("likes")}>
          👌 {facts.likes}
        </button>
        <button className="btn" onClick={() => likehandle("dislikes")}>
          👎 {facts.dislikes}
        </button>
        <button className="btn" onClick={() => likehandle("fake")}>
          🗑️ {facts.fake}
        </button>
      </div>
    </li>
  );
}

// function Counter() {
//   const [count, setCount] = useState(0);

//   return (
//     <div>
//       <span style={{ fontSize: "30px" }}>{count}</span>
//       <button
//         className="btn btn-large"
//         onClick={() => setCount((c) => (count == 0 ? 1 : 0))}
//       >
//         +1
//       </button>
//     </div>
//   );
// }

export default App;
